
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.83 1l5.545 4.028-2.118 6.519H3.403L1.285 5.028z","fill-rule":"nonzero","stroke":"#515358","stroke-width":"1.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/cluster_svgs/polygon.svg